import { GameLaunch } from '../public-api';

export enum EventNames {
    EventClick = 'Event.Clicks',
    EventTracking = 'Event.Tracking',
    GameOpen = 'gameOpen',
    GameInteraction = 'GameInteraction',
}

export enum EventDataKeys {
    ComponentUrlClicked = 'component.URLClicked',
    ComponentGameName = 'component.gameName',
    ComponentGameType = 'component.gameType',
    ComponentGamePosition = 'component.Game.position',
    ComponentGameSection = 'component.Game.section',
    ComponentGameGridPosition = 'component.Game.GridPosition',
    ComponentGameContainerLocation = 'component.gameContainerLocation',
    ComponentGameStatus = 'component.gameStatus',
    ComponentGameContainerDescription = 'component.gameContainerDescription',
    ComponentGameFavorite = 'component.gameFavourite',
    ComponentGamePlayingStatus = 'component.gamePlayingStatus',
    ComponentGameDisplayName = 'component.gameDisplayName',
    ComponentCategoryType = 'component.categoryType',
    ComponentCategorySubType = 'component.categorySubType',
    ComponentRecommendationType = 'component.recommendationtype',
    ComponentGameInteraction = 'component.Game.interaction',
    CasinoLobbyName = 'casino.lobbyName',
    CasinoLobbySource = 'casino.lobbySource',
    CasinoOptimoveSegment = 'casino.optimoveSegment',
    AddGameFavorites = 'Add_Game_Favorites',
    RemoveGameFavourite = 'Remove_Game_Favorites',
    ComponentCategoryEvent = 'component.CategoryEvent',
    ComponentLabelEvent = 'component.LabelEvent',
    ComponentActionEvent = 'component.ActionEvent',
    ComponentPositionEvent = 'component.PositionEvent',
    ComponentLocationEvent = 'component.LocationEvent',
    ComponentEventDetails = 'component.EventDetails',
}

type EventData = {
    [EventDataKeys.ComponentUrlClicked]?: string;
    [EventDataKeys.ComponentGameName]?: string;
    [EventDataKeys.ComponentGameType]?: string;
    [EventDataKeys.ComponentGamePosition]?: number;
    [EventDataKeys.ComponentGameSection]?: string;
    [EventDataKeys.ComponentGameGridPosition]?: string;
    [EventDataKeys.ComponentGameContainerLocation]?: string;
    [EventDataKeys.ComponentGameStatus]?: string;
    [EventDataKeys.ComponentGameContainerDescription]?: string;
    [EventDataKeys.ComponentGameFavorite]?: string;
    [EventDataKeys.ComponentGamePlayingStatus]?: string;
    [EventDataKeys.ComponentGameDisplayName]?: string;
    [EventDataKeys.ComponentCategoryType]?: string;
    [EventDataKeys.ComponentCategorySubType]?: string;
    [EventDataKeys.ComponentRecommendationType]?: string;
    [EventDataKeys.ComponentGameInteraction]?: string;
    [EventDataKeys.CasinoLobbyName]?: string;
    [EventDataKeys.CasinoLobbySource]?: string;
    [EventDataKeys.CasinoOptimoveSegment]?: string;
    [EventDataKeys.CasinoLobbyName]?: string;
    [EventDataKeys.AddGameFavorites]?: string;
    [EventDataKeys.RemoveGameFavourite]?: string;
    [EventDataKeys.ComponentCategoryEvent]?: string;
    [EventDataKeys.ComponentLabelEvent]?: string;
    [EventDataKeys.ComponentActionEvent]?: string;
    [EventDataKeys.ComponentPositionEvent]?: string;
    [EventDataKeys.ComponentLocationEvent]?: string;
    [EventDataKeys.ComponentEventDetails]?: string;
};

export interface Event {
    name: EventNames;
    data: EventData;
}

type ErrorType = {
    message: string;
    code?: string;
};

export interface ErrorEvent {
    data: ErrorType;
}

enum UpdateTypeKeys {
    Event = 'event',
    PageName = 'page.name',
}

type UpdateType = {
    [UpdateTypeKeys.Event]?: string;
    [UpdateTypeKeys.PageName]?: string;
};

export interface DataUpdateEvent {
    data: UpdateType;
}

export interface TrackGame {
    name: string;
    type: string;
    position: number;
    section: string;
    gridPosition: string;
    location: string;
    status: string;
    description: string;
    favourite: string;
    playingStatus: string;
    displayName: string;
    categoryType: string;
    categorySubType: string;
    recommendationType: string;
    lobbyName: string;
    lobbySource: string;
    optimoveSegment: string;
    params: GameLaunch;
}
